import React, { memo } from 'react';
import AccumulatedInterestSection from './AccumulatedInterestSection';
import AddGoalSectionButton from './AddGoalSectionButton';
import PotGoalSection from './PotGoalSection';
const PotsGoalSection = ({ pot }) => {
    switch (pot.type) {
        case 'ACCUMULATED_INTEREST':
        case 'ACCUMULATED_INTEREST_NOTICE':
            return <AccumulatedInterestSection pot={pot}/>;
        default:
            return !pot.goal ? <AddGoalSectionButton pot={pot}/> : <PotGoalSection pot={pot}/>;
    }
};
export default memo(PotsGoalSection);
